export const GET_STATIC_PAGE = 'GET_STATIC_PAGE'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const USER_DATA = 'USER_DATA'
export const USER_PREFERENCES = 'USER_PREFERENCES'
